import mixpanel from 'mixpanel-browser';
import {UserType} from 'js/hooks/useGetUser/useGetUser';
import parse from 'html-react-parser';
import Cookies from 'universal-cookie';


export type EventDataType = {
    name?: string,
    category: string,
    type?: string,
    value?: string,
    selected?:string,
    words?: number,
    characters?: number,
    domain?: string,
    title?: string,
    link?: string,
    productName?: string,
    subjectMaterName?: string,
    courseName?: string,
    section?: string,
    location?:string,
    searchType?: 'AI' | 'Regular'
}

type PageDataType = {
    page: string,
    domain?: string,
    product?: string,
    type?: string,
    entityType?: 'article' | 'video' | 'podcast' | 'self-learning'
}

class MixPanelWrapper {
    static REACT_APP_MIXPANEL_TOKEN:string = process?.env?.REACT_APP_MIXPANEL_TOKEN || '';
    static REACT_APP_MIX_PANEL_INIT_COOKIE:string = process?.env?.REACT_APP_MIX_PANEL_INIT_COOKIE || '';
    static REACT_APP_LOCAL_LINK:string = process?.env?.REACT_APP_LOCAL_LINK || '';
    static REACT_APP_PROD_LINK:string = process?.env?.REACT_APP_PROD_LINK || '';
    mpCookie:string = '';
    INIT_MIX_PANEL:boolean = false;
    CookiesList:Cookies = new Cookies(null);

    async Init(userData: UserType, isLoggedIn: boolean, debugMode: boolean = false) {

        const isMixPanelAccepted:boolean = this?.CookiesList.get(MixPanelWrapper.REACT_APP_MIX_PANEL_INIT_COOKIE) === 'true';

        if (!isLoggedIn || !isMixPanelAccepted || !userData) {
            return;
        }
        // eslint-disable-next-line babel/camelcase
        mixpanel.init(MixPanelWrapper.REACT_APP_MIXPANEL_TOKEN, {debug: debugMode, api_host: 'https://api-eu.mixpanel.com'});
        const {
            uuid,
            position,
            company,
            playtechUser
        } = userData || {};

        mixpanel.identify(uuid);
        this.INIT_MIX_PANEL = true;
        await mixpanel.people.set_once({
            Role: position,
            Company: company,
            'Playtech User': `${playtechUser ? 'Yes' : 'No'}`
        });
    }
    async GetMpCookie() {
        const allCookies = this?.CookiesList?.getAll();
        this.mpCookie = Object?.keys(allCookies)?.find(key => key?.startsWith('mp_'));
    }

    async TrackEvent(eventName: string, eventData: EventDataType) {
        if (!eventName || !eventData || !this.INIT_MIX_PANEL) {
            return;
        }
        if (eventData?.value) {
            eventData.value = `${parse(eventData.value)}`;
        }
        eventData.domain = window?.location?.origin;
        return await mixpanel.track(eventName, eventData);
    }
    async TrackPageView(data: PageDataType) {
        if (!data?.page || !this.INIT_MIX_PANEL) {
            return;
        }
        data.page = `${parse(data.page)}`;
        data.domain = window?.location?.origin;
        return mixpanel.track_pageview(data);
    }

    async RemoveMixPanel(removeInit = false) {
        const options = {
            path: '/',
            domain: `.${location.hostname}`
        };
        await this.GetMpCookie();

        if (window.location.origin === MixPanelWrapper.REACT_APP_LOCAL_LINK ||
            window.location.origin === MixPanelWrapper.REACT_APP_PROD_LINK) {
            options.domain = `.${location.hostname}`;
        } else {
            options.domain = '.playtech.corp';
        }
        this.CookiesList.remove(this.mpCookie, options);

        if (removeInit) {
            this.CookiesList.remove(MixPanelWrapper.REACT_APP_MIX_PANEL_INIT_COOKIE, {
                path: '/',
                domain: `.${location.hostname}`
            });
        }
    }
}

export default new MixPanelWrapper();
